import classNames from 'classnames';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import React from 'react';
import ScratchBlocks from 'scratch-blocks';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import CommunityButton from './community-button.jsx';
import ShareButton from './share-button.jsx';
import { ComingSoonTooltip } from '../coming-soon/coming-soon.jsx';
import Divider from '../divider/divider.jsx';
import LanguageSelector from '../../containers/language-selector.jsx';
import SaveStatus from './save-status.jsx';
import SBFileUploader from '../../containers/sb-file-uploader.jsx';
import ProjectWatcher from '../../containers/project-watcher.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import { MenuItem, MenuSection } from '../menu/menu.jsx';
import ProjectTitleInput from './project-title-input.jsx';
import AuthorInfo from './author-info.jsx';
import AccountNav from '../../containers/account-nav.jsx';
import LoginDropdown from './login-dropdown.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import DeletionRestorer from '../../containers/deletion-restorer.jsx';
import TurboMode from '../../containers/turbo-mode.jsx';
import GetSerialPort from '../../containers/get-serialport.jsx';
import DisconnectToPort from '../../containers/disconnectto-port.jsx';
import SaveFile from '../../containers/SaveFile.jsx';

import { setProjectChanged } from '../../reducers/project-changed';
import { btnHideFalse, setSaveFilePath, setSavePythonPath } from '../../reducers/menus.js'

import { openTipsLibrary, openFeedBack, openLogin } from '../../reducers/modals';
import { setPlayer, setLinkMode } from '../../reducers/mode';
import {
    autoUpdateProject,
    getIsUpdating,
    getIsShowingProject,
    manualUpdateProject,
    requestNewProject,
    remixProject,
    saveProjectAsCopy
} from '../../reducers/project-state';
import {
    openAccountMenu,
    closeAccountMenu,
    accountMenuOpen,
    openFileMenu,
    closeFileMenu,
    fileMenuOpen,
    openEditMenu,
    closeEditMenu,
    editMenuOpen,
    openLanguageMenu,
    closeLanguageMenu,
    languageMenuOpen,
    openLoginMenu,
    closeLoginMenu,
    loginMenuOpen,
    closeCreateFile,
    openCreateFile
} from '../../reducers/menus';

import styles from './menu-bar.css';

import helpIcon from '../../lib/assets/icon--tutorials.png';
import mystuffIcon from './icon--mystuff.png';
import editIcon from './icon--edit.png';
import fileIcon from './icon--file.png';
import offLine from './icon--offline.png';
import connected from './icon--connected.png';
import share from './icon--share.png';
import login from './icon--login.png';
import blockIcon from './icon-block.png';
import feedbackIcon from './icon--feedback.svg';
import profileIcon from './icon--profile.png';
import remixIcon from './icon--remix.svg';
import dropdownCaret from './dropdown-caret.svg';
import languageIcon from '../language-selector/language-icon.svg';
import feedback from './icon-feedback.svg';
import lineBle from './icon--ble.png';
import lineUsb from './icon--usb.png';
import line from './icon--line.svg';
import closeIcon from './icon--close.svg';

import scratchLogo from './ZMROBO.png';
import { clearTimeout } from 'timers';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}
const messages = defineMessages({
    confirmNav: {
        id: 'gui.menuBar.confirmNewWithoutSaving',
        defaultMessage: 'Replace contents of the current project?',
        description: 'message for prompting user to confirm that they want to create new project without saving'
    },
    defaultProjectTitle: {
        id: 'gui.gui.defaultProjectTitle',
        description: 'Default title for project',
        defaultMessage: 'Scratch Project'
    }
});

const ariaMessages = defineMessages({
    language: {
        id: 'gui.menuBar.LanguageSelector',
        defaultMessage: 'language selector',
        description: 'accessibility text for the language selection menu'
    },
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Tutorials',
        description: 'accessibility text for the tutorials button'
    }
});

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return (
        <ComingSoonTooltip
            className={classNames(styles.comingSoon, className)}
            place={place}
            tooltipClassName={styles.comingSoonTooltip}
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};


MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const MenuItemTooltip = ({ id, isRtl, children, className }) => (
    <ComingSoonTooltip
        className={classNames(styles.comingSoon, className)}
        isRtl={isRtl}
        place={isRtl ? 'left' : 'right'}
        tooltipClassName={styles.comingSoonTooltip}
        tooltipId={id}
    >
        {children}
    </ComingSoonTooltip>
);

MenuItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool
};

class MenuBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Countdown: 'block',
            closeBtn: 'none',
            // unlink: 'block',   // 未连接图标
            // linked: 'none',    // 已连接图标
        };
        bindAll(this, [
            'handleConfirm',
            'handleClickNew',
            'handleClickRemix',
            'handleClickSave',
            'handleClickSaveAsCopy',
            'handleClickSeeCommunity',
            'handleClickShare',
            'handleClose',
            'handleCloseFileMenuAndThen',
            'handlelineUsb',
            'handlelineHid',
            'handleLanguageMouseUp',
            'handleRestoreOption',
            'restoreOptionMessage',
            'handleSignout',
            'handleClickMenuFile',
            'handleClickUpdate',
            'handleCheckUpdate',
            'handleShowUpdate',
            'handleGetVersion',
            'handleInstallDrive',
            'handleMouseover',
            'handleTip2close',
            'handlehideMenu',
            'versionCallback',
            'onopenBlockTip',
            'handleSaveComputeFile'
        ]);
    }
    componentDidMount() {
        // 给页面绑定事件,点击页面任意地方,隐藏弹出层-->点击连接按钮提示没找到设备时的弹出层
        document.addEventListener('click', this.handlehideMenu);
    }
    handlehideMenu() {
        document.getElementsByClassName('menu-bar_tip2_1mEA3')[0].style.display = 'none';
    }
    handleConfirm() {
        if (window.saveIcon != undefined) {
            saveIcon = true;
        }
        this.props.setStateFalse('showStage');
        this.props.clickToBlockpanel() //处在python编辑区时，点击新建切换到积木
        this.props.btnFalse()
        var code = document.getElementById('codeSmallBtn')
        code.style.display = 'block';

        this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
        this.props.onUpdateProjectTitle(this.props.intl.formatMessage(messages.defaultProjectTitle))
        document.getElementsByClassName('menu-bar_tip6Box_2q_v6')[0].style.display = 'none';
    }
    handleClear(e) {
        // 清除代码编辑器的代码
        editor.setValue("");
        document.getElementsByClassName('menu-bar_tip11Box_nD3Th')[0].style.display = 'none';
    }
    handleCancle() {
        document.getElementsByClassName('menu-bar_tip6Box_2q_v6')[0].style.display = 'none';
        // 关闭清除代码提示
        document.getElementsByClassName('menu-bar_tip11Box_nD3Th')[0].style.display = 'none';
    }
    // 选择连接方式窗口关闭按钮
    handleClose() {
        document.getElementsByClassName('menu-bar_tip9Bg_1TNEL')[0].style.display = 'none';
    }
    // 连接方式--USB（蓝牙）
    handlelineUsb() {
        // E6连接指令也是USB_CONNECTION，所以这里加上rcu做区分
        let data = {
            command: 'USB_CONNECTION',
            rcu: 'C1'
        }
        ipcRenderer && ipcRenderer.send('udp_cmd', data)
        this.props.onsetLinkMode('BLUETOOTH')
    }
    // 连接方式--HID
    handlelineHid() {
        ipcRenderer && ipcRenderer.send('udp_cmd', 'HID_CONNECTION')
        this.props.onsetLinkMode('HID')
    }
    // 退出登录
    handleSignout() {
        document.getElementsByClassName('menu-bar_loginBtn_NnVMb')[0].style.display = 'inline-block';
        document.getElementsByClassName('menu-bar_signoutBtn_1lg8h')[0].style.display = 'none';
    }
    handleClickNew() {

        if (this.props.showtitle) {

            let readyToReplaceProject = true;
            // if the project is dirty, and user owns the project, we will autosave.
            // but if they are not logged in and can't save, user should consider
            // downloading or logging in first.
            // Note that if user is logged in and editing someone else's project,
            // they'll lose their work.
            if (this.props.projectChanged && !this.props.canCreateNew) {
                this.props.onOpenCreateFile();
                // readyToReplaceProject = confirm( // eslint-disable-line no-alert
                //     this.props.intl.formatMessage(messages.confirmNav)
                // );
            } else {
                this.props.onCloseCreateFile()
            }
            document.getElementsByClassName('menu-bar_tip6Box_2q_v6')[0].style.display = 'block';
            // this.props.onRequestCloseFile();
            // if (readyToReplaceProject) {
            //     this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            // }
            // this.props.onRequestCloseFile();
            this.props.setSaveFilePath(null)
            this.props.setSavePythonPath(null)
        } else {

            let intl = this.props.intl
            ScratchBlocks.customConfirm(intl.formatMessage({
                id: 'gui.menuBar.tip11Title',
                defaultMessage: "清除代码",
                description: "Text for tip11"
            }), intl.formatMessage({
                id: "gui.menuBar.tip11",
                defaultMessage: "确认清除所有代码？",
                description: "Text for tip11"
            }), () => {
                this.props.setMonaCodeValue('')
            })
        }

    }
    handleClickRemix() {
        this.props.onClickRemix();
        this.props.onRequestCloseFile();
    }
    handleClickSave() {
        this.props.onClickSave();
        this.props.onRequestCloseFile();
    }
    handleClickSaveAsCopy() {
        this.props.onClickSaveAsCopy();
        this.props.onRequestCloseFile();
    }
    handleClickSeeCommunity(waitForUpdate) {
        if (this.props.canSave) { // save before transitioning to project page
            this.props.autoUpdateProject();
            waitForUpdate(true); // queue the transition to project page
        } else {
            waitForUpdate(false); // immediately transition to project page
        }
    }
    handleClickShare(waitForUpdate) {
        if (!this.props.isShared) {
            if (this.props.canShare) { // save before transitioning to project page
                this.props.onShare();
            }
            if (this.props.canSave) { // save before transitioning to project page
                this.props.autoUpdateProject();
                waitForUpdate(true); // queue the transition to project page
            } else {
                waitForUpdate(false); // immediately transition to project page
            }
        }
    }

    handleClickMenuFile() {
        this.props.onClickFile()
        this.props.setStateFalse('bubble')
    }

    handleRestoreOption(restoreFun) {
        return () => {
            restoreFun();
            this.props.onRequestCloseEdit();
        };
    }
    handleCloseFileMenuAndThen(fn) {
        return () => {
            this.props.onRequestCloseFile();
            fn();
        };
    }

    //点击 ‘固件升级’ 按钮
    handleClickUpdate() {
        //定制版本，直接拷贝本地的一个固件到磁盘
        // this.props.onRequestCloseFile()
        // ipcRenderer && ipcRenderer.send("copyToDisk")
        // return
        let firmVersion = ipcRenderer.sendSync('getFirmVersion')
        window.__yourReactComp__.setState({
            isMenuClick: true
        })
        if (ipcRenderer) {
            let isOnline = ipcRenderer.sendSync('isOnline')
            if (!isOnline) {
                this.props.onRequestCloseFile()
                downloadAlert({
                    show: true,
                    type: 'Error',
                    content: '没有网络',
                    animation: true,
                    duration: 2000
                })
                window.__yourReactComp__.setState({
                    isMenuClick: false
                })
                return
            }
        }

        if (!this.props.link) {
            document.getElementsByClassName('menu-bar_lineBtn_SJHIC')[0].click()
            this.props.onRequestCloseFile()
            return
        }


        if (this.props.vm.robotType == 'C1') {
            this.handleGetVersion('c1', this.versionCallback(firmVersion))
        }
        // 注意外层判断E是大写，里面的e是小写
        else if (this.props.vm.robotType == 'E6') {
            this.handleGetVersion('e6', this.versionCallback(firmVersion))
        }
        else if (this.props.vm.robotType == 'M6') {
            // 测试时为e6，需改动为m6
            this.handleGetVersion('m6', this.versionCallback(firmVersion))
        } else if (this.props.vm.robotType == 'M5') {
            this.handleShowUpdate(1);
        } else if (this.props.vm.robotType == 'E3') {
            window.downloadAlert({ show: true, type: 'Error', content: "E3 暂时不支持固件更新。", animation: true, duration: 2000 })
            this.props.onRequestCloseFile()
        }


    }
    versionCallback(firmVersion) {
        return (data) => {
            var Data = JSON.parse(data)
            this.props.handleSetVersion({
                name: Data.name,
                current: firmVersion,
                lastest: Data.version
            })
            // 需改回来  this.props.hasUpdate
            if (this.props.hasUpdate) {
                this.handleShowUpdate(1);
            } else {
                this.handleShowUpdate(8);
            }
        }
    }

    //请求远程数据获取固件最新版本
    handleGetVersion(type, callback) {
        var url = 'https://edu.zmrobo.com/scratchHelp/getversion.php';
        let formdata = new FormData();
        formdata.append("type", type);
        fetch(url, {
            method: 'POST',
            headers: {},
            body: formdata
        }).then((response) => {
            return response.text();
        }).then((json) => {
            callback(json)
        }).catch((error) => {
            console.error(error);
        });
    }

    //点击 ‘检测更新’ 按钮
    handleCheckUpdate() {
        this.props.onRequestCloseFile();
        ipcRenderer && ipcRenderer.send('udp_cmd', 'GEN_APPLICATION_UPDATE')
    }
    //根据传入的num判断显示哪个更新弹窗
    handleShowUpdate(num) {
        this.props.setupdateProgress(num);
        this.props.setStateTrue('isUpdateBox');
        window.__yourReactComp__.setState({
            isMenuClick: false
        })
        this.props.onRequestCloseFile();
    }

    handleLanguageMouseUp(e) {
        // if (!this.props.languageMenuOpen) {
        //     this.props.onClickLanguage(e);
        // }
        if (!this.props.languageMenuOpen) {
            this.props.onClickLanguage(e);
            document.addEventListener('click', this.handleLanguageMouseUp, false)
        } else {
            this.props.onRequestCloseLanguage(e)
            document.removeEventListener('click', this.handleLanguageMouseUp, false)
        }
    }

    // 检查是否安装串口驱动程序
    handleInstallDrive() {
        let json = {
            command: 'USB_DRIVER_INSTALL',
            operation: 'check'
        };
        const order = JSON.stringify(json);
        jsObj.SendToBrowser(order);
    }
    // 鼠标移入检查是否安装串口驱动程序窗口时，窗口5s后不关闭
    handleMouseover() {
        this.setState({
            Countdown: 'none',
            closeBtn: 'flex'
        })
        window.clearTimeout(tip2_2_timeout)
        window.clearTimeout(tip2_3_timeout)
        window.clearInterval(inter)
        window.clearInterval(inter2)
    }
    // 关闭检查是否安装串口驱动程序窗口
    handleTip2close() {
        document.getElementsByClassName('menu-bar_tip2_1mEA3')[0].style.display = 'none';
        this.setState({
            Countdown: 'block',
            closeBtn: 'none'
        })
    }
    // // 切换连接按钮状态
    // changeLinkBtnState (val1, val2) {
    //     this.setState({
    //         unlink: val1,
    //         linked: val2
    //     })
    // }
    onopenBlockTip() {

    }
    handleSaveComputeFile(fn) {
        return () => {
            this.props.onRequestCloseFile(),
                fn()
        }
    }
    restoreOptionMessage(deletedItem) {
        switch (deletedItem) {
            case 'Sprite':
                return (<FormattedMessage
                    defaultMessage="Restore Sprite"
                    description="Menu bar item for restoring the last deleted sprite."
                    id="gui.menuBar.restoreSprite"
                />);
            case 'Sound':
                return (<FormattedMessage
                    defaultMessage="Restore Sound"
                    description="Menu bar item for restoring the last deleted sound."
                    id="gui.menuBar.restoreSound"
                />);
            case 'Costume':
                return (<FormattedMessage
                    defaultMessage="Restore Costume"
                    description="Menu bar item for restoring the last deleted costume."
                    id="gui.menuBar.restoreCostume"
                />);
            default: {
                return (<FormattedMessage
                    defaultMessage="Restore"
                    description="Menu bar item for restoring the last deleted item in its disabled state." /* eslint-disable-line max-len */
                    id="gui.menuBar.restore"
                />);
            }
        }
    }
    render() {
        const saveNowMessage = (
            <FormattedMessage
                defaultMessage="Save now"
                description="Menu bar item for saving now"
                id="gui.menuBar.saveNow"
            />
        );
        const createCopyMessage = (
            <FormattedMessage
                defaultMessage="Save as a copy"
                description="Menu bar item for saving as a copy"
                id="gui.menuBar.saveAsCopy"
            />
        );
        const remixMessage = (
            <FormattedMessage
                defaultMessage="Remix"
                description="Menu bar item for remixing"
                id="gui.menuBar.remix"
            />
        );
        const newProjectMessage = (
            <FormattedMessage
                defaultMessage="New"
                description="Menu bar item for creating a new project"
                id="gui.menuBar.new"
            />
        );
        const remixButton = (
            <Button
                className={classNames(
                    styles.menuBarButton,
                    styles.remixButton
                )}
                iconClassName={styles.remixButtonIcon}
                iconSrc={remixIcon}
                onClick={this.handleClickRemix}
            >
                {remixMessage}
            </Button>
        );
        const {
            blockClose,
            robotType,
            downArray,
            isClose,
            showtitle,
            clickToBlockpanel,
            clickToEditpanel,
            signOut,
            isLogout,
            bubble,
            hasUpdate,
            setStateTrue,
            setStateFalse,
            vm
        } = this.props
        return (
            <Box
                className={classNames(
                    this.props.className,
                    styles.menuBar
                )}
            >
                <div className={styles.mainMenu}>
                    <div className={styles.fileGroup}>
                        <div className={classNames(styles.menuBarItem)}>
                            <img
                                alt="Scratch"
                                className={classNames(styles.scratchLogo, {
                                    [styles.clickable]: typeof this.props.onClickLogo !== 'undefined'
                                })}
                                draggable={false}
                                src={scratchLogo}
                            // onClick={this.props.onClickLogo}
                            />
                        </div>
                        <div
                            className={classNames(styles.menuBarItem, styles.hoverable, styles.languageMenu, { [styles.openState]: this.props.languageMenuOpen })}
                        >
                            <div
                                className={styles.clickOpen}
                                onClick={this.handleLanguageMouseUp}>
                                <img
                                    className={styles.languageIcon}
                                    src={languageIcon}
                                />
                                <img
                                    className={styles.languageCaret}
                                    src={dropdownCaret}
                                />
                            </div>
                            <LanguageSelector
                                vm={vm}
                                label={this.props.intl.formatMessage(ariaMessages.language)}
                                languageMenuOpen={this.props.languageMenuOpen}
                                clickToBlockpanel={clickToBlockpanel}
                                clickToEditpanel={clickToEditpanel}
                                setStateFalse={setStateFalse}
                                setStateTrue={setStateTrue}
                            />
                            {/* <LanguageSelector
                                vm={vm}
                                label={this.props.intl.formatMessage(ariaMessages.language)} /> */}
                        </div>
                        <div
                            className={classNames(styles.menuBarItem, styles.hoverable, {
                                [styles.active]: this.props.fileMenuOpen
                            })}
                            onMouseUp={this.handleClickMenuFile}
                        >
                            <img
                                className={styles.fileIcon}
                                src={fileIcon}
                            />
                            <FormattedMessage
                                defaultMessage="File"
                                description="Text for file dropdown menu"
                                id="gui.menuBar.file"
                            />
                            <MenuBarMenu
                                className={classNames(styles.menuBarMenu)}
                                open={this.props.fileMenuOpen}
                                place={this.props.isRtl ? 'left' : 'right'}
                                onRequestClose={this.props.onRequestCloseFile}
                            >
                                <MenuSection>
                                    <MenuItem
                                        isRtl={this.props.isRtl}
                                        onClick={this.handleClickNew}
                                    >
                                        {newProjectMessage}
                                    </MenuItem>
                                </MenuSection>
                                {(this.props.canSave || this.props.canCreateCopy || this.props.canRemix) && (
                                    <MenuSection>
                                        {this.props.canSave ? (
                                            <MenuItem onClick={this.handleClickSave}>
                                                {saveNowMessage}
                                            </MenuItem>
                                        ) : []}
                                        {this.props.canCreateCopy ? (
                                            <MenuItem onClick={this.handleClickSaveAsCopy}>
                                                {createCopyMessage}
                                            </MenuItem>
                                        ) : []}
                                        {this.props.canRemix ? (
                                            <MenuItem onClick={this.handleClickRemix}>
                                                {remixMessage}
                                            </MenuItem>
                                        ) : []}
                                    </MenuSection>
                                )}
                                <MenuSection>
                                    <SBFileUploader onUpdateProjectTitle={this.props.onUpdateProjectTitle}>
                                        {(className, renderFileInput, loadProject) => (
                                            <MenuItem
                                                className={className}
                                                onClick={loadProject}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Load from your computer"
                                                    description={
                                                        'Menu bar item for uploading a project from your computer'
                                                    }
                                                    id="gui.menuBar.uploadFromComputer"
                                                />
                                                {renderFileInput()}
                                            </MenuItem>
                                        )}
                                    </SBFileUploader>
                                    <SB3Downloader>{(className, downloadProject) => (
                                        <MenuItem
                                            className={className}
                                            onClick={this.handleCloseFileMenuAndThen(downloadProject)}
                                        >
                                            <FormattedMessage
                                                defaultMessage="Save As"
                                                description='Save As'
                                                id="gui.menuBar.saveAs"
                                            />
                                        </MenuItem>
                                    )}</SB3Downloader>
                                    <SaveFile>
                                        {(saveFileFn) => (
                                            window.require !== undefined && <MenuItem
                                                onClick={this.handleSaveComputeFile(saveFileFn)}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Save to your computer"
                                                    description="Menu bar item for downloading a project to your computer"
                                                    id="gui.menuBar.downloadToComputer"
                                                />
                                            </MenuItem>
                                        )}
                                    </SaveFile>
                                </MenuSection>
                                {/* 固件升级按钮 */}
                                {
                                    window.require && <MenuSection>
                                        <MenuItem onClick={this.handleClickUpdate}>
                                            {hasUpdate ? (<div className={styles.newTip}></div>) : null}
                                            <FormattedMessage
                                                defaultMessage="Firmware Update"
                                                description="update Item"
                                                id="gui.menuBar.updateItem"
                                            />
                                        </MenuItem>
                                    </MenuSection>
                                }
                                {/* 检测更新按钮 */}
                                {
                                    window.require && <MenuSection>
                                        <MenuItem onClick={this.handleCheckUpdate}>
                                            <FormattedMessage
                                                defaultMessage="Check update"
                                                description="Check update"
                                                id="gui.menuBar.checkUpdate"
                                            />
                                        </MenuItem>
                                    </MenuSection>
                                }
                            </MenuBarMenu>
                        </div>
                        {bubble ? (
                            <div className={classNames(styles.bubble, { [styles.showBubble]: bubble })}>
                                <FormattedMessage
                                    defaultMessage="New firmware needs to be updated"
                                    description="update Bubble"
                                    id="gui.menuBar.updateBubble"
                                />
                                <div className={classNames(styles.bubbleKnow)} onClick={() => { setStateFalse('bubble') }}>
                                    <FormattedMessage
                                        defaultMessage="confirm"
                                        description="bubble Confirm"
                                        id="gui.menuBar.bubbleConfirm"
                                    />
                                </div>
                            </div>
                        ) : null}

                        {/* <div
                            className={classNames(styles.menuBarItem, styles.hoverable, {
                                [styles.active]: this.props.editMenuOpen
                            })}
                            onMouseUp={this.props.onClickEdit}
                        >
                            <img
                                className={styles.editIcon}
                                src={editIcon}
                            />
                            <div className={classNames(styles.editMenu)}>
                                <FormattedMessage
                                    defaultMessage="Edit"
                                    description="Text for edit dropdown menu"
                                    id="gui.menuBar.edit"
                                />
                            </div>
                            <MenuBarMenu
                                className={classNames(styles.menuBarMenu)}
                                open={this.props.editMenuOpen}
                                place={this.props.isRtl ? 'left' : 'right'}
                                onRequestClose={this.props.onRequestCloseEdit}
                            >
                                <DeletionRestorer>{(handleRestore, {restorable, deletedItem}) => (
                                    <MenuItem
                                        className={classNames({[styles.disabled]: !restorable})}
                                        onClick={this.handleRestoreOption(handleRestore)}
                                    >
                                        {this.restoreOptionMessage(deletedItem)}
                                    </MenuItem>
                                )}</DeletionRestorer>
                                <MenuSection>
                                    <TurboMode>{(toggleTurboMode, {turboMode}) => (
                                        <MenuItem onClick={toggleTurboMode}>
                                            {turboMode ? (
                                                <FormattedMessage
                                                    defaultMessage="Turn off Turbo Mode"
                                                    description="Menu bar item for turning off turbo mode"
                                                    id="gui.menuBar.turboModeOff"
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    defaultMessage="Turn on Turbo Mode"
                                                    description="Menu bar item for turning on turbo mode"
                                                    id="gui.menuBar.turboModeOn"
                                                />
                                            )}
                                        </MenuItem>
                                    )}</TurboMode>
                                </MenuSection>
                            </MenuBarMenu>
                        </div> */}
                        <div className={classNames(styles.lineBtnBox)}>
                            <div className={classNames(styles.serialportBox)}>
                                {this.props.link ? <DisconnectToPort
                                // handleShow= {this.changeLinkBtnState.bind(this)}
                                >{(disconnectToPort, { turboMode }) => (
                                    <div
                                        className={classNames(styles.outlineBtn)}
                                        onClick={disconnectToPort}
                                    >
                                        <img
                                            className={styles.selectIcon}
                                            src={connected}

                                        />
                                        <FormattedMessage
                                            defaultMessage="connected"
                                            id="gui.menuBar.connected"
                                        />
                                    </div>
                                )}</DisconnectToPort> :
                                    <GetSerialPort
                                    // handleShow= {this.changeLinkBtnState.bind(this)}
                                    >{(getSerialPort, { turboMode }) => (
                                        <div
                                            className={classNames(styles.menuBarItem, styles.lineBtn)}
                                            onClick={getSerialPort}
                                        >
                                            <img
                                                className={styles.selectIcon}
                                                src={offLine}

                                            />
                                            <FormattedMessage
                                                defaultMessage="link"
                                                description="Text for link"
                                                id="gui.menuBar.link"
                                            />
                                        </div>
                                    )}</GetSerialPort>}
                            </div>
                            <div className={classNames(styles.portBox)}>
                                {/* <TurboMode>{(toggleTurboMode, {turboMode}) => (
                                    <MenuItem onClick={toggleTurboMode}>
                                        <div className={classNames(styles.port1)} >
                                            <FormattedMessage
                                                defaultMessage="port1"
                                                description="line to port1"
                                                id="gui.menuBar.port1"
                                            />
                                        </div>
                                    </MenuItem>
                                )}</TurboMode>
                                <TurboMode>{(toggleTurboMode, {turboMode}) => (
                                    <MenuItem onClick={toggleTurboMode}>
                                        <div className={classNames(styles.port2)} >
                                            <FormattedMessage
                                                defaultMessage="port2"
                                                description="line to port2"
                                                id="gui.menuBar.port2"
                                            />
                                        </div>
                                    </MenuItem>
                                )}</TurboMode> */}
                            </div>
                        </div>
                    </div>
                    <Divider className={classNames(styles.divider)} />
                    <div
                        aria-label={this.props.intl.formatMessage(ariaMessages.tutorials)}
                        className={classNames(styles.menuBarItem, styles.hoverable)}
                        onClick={this.props.onOpenTipLibrary}
                    >
                        <img
                            className={styles.helpIcon}
                            src={helpIcon}
                        />
                        <FormattedMessage {...ariaMessages.tutorials} />
                    </div>
                    <Divider className={classNames(styles.divider)} />
                    {this.props.canEditTitle ? (
                        <div className={classNames(styles.menuBarItem, styles.growable)}>
                            <MenuBarItemTooltip
                                enable
                                id="title-field"
                            >
                                <ProjectTitleInput
                                    className={classNames(styles.titleFieldGrowable)}
                                    onUpdateProjectTitle={this.props.onUpdateProjectTitle}
                                />
                            </MenuBarItemTooltip>
                        </div>
                    ) : ((this.props.authorUsername && this.props.authorUsername !== this.props.username) ? (
                        <AuthorInfo
                            className={styles.authorInfo}
                            imageUrl={this.props.authorThumbnailUrl}
                            projectTitle={this.props.projectTitle}
                            userId={this.props.authorId}
                            username={this.props.authorUsername}
                        />
                    ) : null)}
                    <div
                        className={classNames(styles.menuBarItem, styles.shareBtn)}
                    >
                        <MenuItemTooltip
                            enable
                            id="title-field"
                        >
                            <img
                                className={styles.shareIcon}
                                src={share}
                            />
                            <FormattedMessage
                                defaultMessage="share"
                                description="Text for share"
                                id="gui.menuBar.share"
                            />
                        </MenuItemTooltip>
                    </div>
                    <div className={classNames(styles.menuBarPython)}>

                        <div
                            className={classNames(
                                styles.menuBarPythonOne,
                                { [styles.menuBg]: isClose === 1 }
                            )}
                            onClick={downArray.indexOf(robotType) != -1 ? blockClose : null}
                        >
                            <img
                                className={styles.codeIcon}
                                src={blockIcon}
                            />
                            <span>{showtitle ? <FormattedMessage
                                defaultMessage="Block"
                                description="Button to get to the block panel"
                                id="gui.gui.blockPanel"
                            /> : <FormattedMessage
                                defaultMessage="Python"
                                description="Button to get to the edit panel"
                                id="gui.gui.editPanel"
                            />}</span>
                            <img
                                className={classNames(styles.pullDown, { [styles.pullUp]: isClose === 1 })}
                                src={dropdownCaret}
                            />
                        </div>
                        <div className={classNames(styles.menuBarPythonItem, { [styles.menuBarPythonItemShow]: isClose === 0 })}>

                            <div
                                onClick={clickToBlockpanel}
                            >
                                <FormattedMessage
                                    defaultMessage="Block"
                                    description="Button to get to the block panel"
                                    id="gui.gui.blockPanel"
                                />
                            </div>
                            <div
                                onClick={clickToEditpanel}
                            >
                                <FormattedMessage
                                    defaultMessage="Python"
                                    description="Button to get to the edit panel"
                                    id="gui.gui.editPanel"
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div
                        className={classNames(styles.feedback)}
                        style={{ right: '7rem' }}
                        onClick={this.props.onopenBlockTip}
                    >
                        <img
                            alt=""
                            className={styles.loginIcon}
                            src={feedback}
                            title="反馈"
                        />
                    </div> */}
                    {/* <div
                        className={classNames(styles.feedback)}
                        onClick={this.props.onopenFeedBack}
                    >
                        <img
                            alt=""
                            className={styles.loginIcon}
                            src={feedback}
                            title="反馈"
                        />
                    </div> */}
                    {/* <div
                        className={classNames(styles.loginBtn)}
                        onClick={this.props.onopenLogin}
                    >
                        <img
                            className={styles.loginIcon}
                            src={login}
                        />
                    </div> */}
                    <div
                        className={classNames(styles.signoutBtn)}
                        onClick={signOut}
                    >
                        <img
                            className={styles.logoutIcon}
                            src={login}
                        />
                    </div>
                    <div className={classNames(styles.menuBarLogoutBtn, { [styles.menuBarLogoutBtnShow]: isLogout === 0 })}>
                        <div
                            onClick={this.handleSignout}
                        >
                            <FormattedMessage
                                defaultMessage="Sign out"
                                description="Button to sign out"
                                id="gui.gui.logoutbtn"
                            />
                        </div>
                    </div>
                    <div className={classNames(styles.tip_bg)}>
                        <div className={classNames(styles.tip)}>
                            <FormattedMessage
                                defaultMessage="请连接串口"
                                description="Text for tip"
                                id="gui.menuBar.tip"
                            />
                        </div>
                    </div>
                    <div className={classNames(styles.tip2)}
                        onMouseOver={this.handleMouseover}
                    >
                        <FormattedMessage
                            defaultMessage="无法获取到串口"
                            description="Text for tip2"
                            id="gui.menuBar.tip2"
                        />
                        {robotType == "E6" ? (<div className={classNames(styles.tip2_1)}
                            onClick={this.handleInstallDrive}
                        >
                            <FormattedMessage
                                defaultMessage="是否没有安装串口驱动程序？"
                                description="Text for tip2-1"
                                id="gui.menuBar.tip2-1"
                            />
                        </div>) : (<div className={classNames(styles.tip2_3)}>
                            <FormattedMessage
                                defaultMessage="无法识别设备，请尝试更换其他USB接口"
                                description="Text for tip2-3"
                                id="gui.menuBar.tip2-3"
                            />
                        </div>)}

                        <div style={{ display: this.state.Countdown }}
                            className={classNames(styles.tip2_2)}
                        >
                            5
                        </div>
                        <div style={{ display: this.state.closeBtn }}
                            className={classNames(styles.closeBox)}
                            onClick={this.handleTip2close}
                        >
                            <img
                                className={classNames(styles.closeIcon)}
                                src={closeIcon} />
                        </div>
                    </div>
                    <div className={classNames(styles.tip3)}>
                        <FormattedMessage
                            defaultMessage="下载成功"
                            description="Text for tip3"
                            id="gui.menuBar.tip3"
                        />
                    </div>
                    <div className={classNames(styles.tip4)}>
                        <FormattedMessage
                            defaultMessage="保存成功"
                            description="Text for tip4"
                            id="gui.menuBar.tip4"
                        />
                    </div>
                    <div className={classNames(styles.tip5)}>
                        <FormattedMessage
                            defaultMessage="error msg for debug"
                            description="Text for tip5"
                            id="gui.menuBar.tip5"
                        />
                    </div>
                    <div className={classNames(styles.tip6Box)}>
                        <div className={classNames(styles.tip6)}>

                            <div className={classNames(styles.tip6Title)}>
                                <FormattedMessage
                                    defaultMessage="New"
                                    description="Menu bar item for creating a new project"
                                    id="gui.menuBar.new"
                                />
                                <div
                                    className={classNames(styles.closeBox)}
                                    onClick={this.handleCancle}
                                >
                                    <img
                                        className={classNames(styles.closeIcon)}
                                        src={closeIcon} />
                                </div>
                            </div>
                            <div className={classNames(styles.tip6Content)}>
                                <div className={classNames(styles.text)}>
                                    {this.props.isCreateFile ? (<FormattedMessage

                                        defaultMessage="Replace contents of the current project?"
                                        description="Text for tip6"
                                        id="gui.menuBar.tip6"
                                    />) : (<FormattedMessage
                                        defaultMessage="Create new project?"
                                        description="Text for tip6-1"
                                        id="gui.menuBar.tip6-1"
                                    />)}
                                </div>
                                <div className={classNames(styles.tip6Btn)}>
                                    <button
                                        className={classNames(styles.cancle)}
                                        onClick={this.handleCancle}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Close"
                                            description="Close"
                                            id="gui.prompt.cancel"
                                        />
                                    </button>
                                    <button
                                        className={classNames(styles.confirm)}
                                        onClick={this.handleConfirm}
                                    >
                                        <FormattedMessage
                                            defaultMessage="OK"
                                            description="OK"
                                            id="gui.prompt.ok"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classNames(styles.tip7)}>
                        <FormattedMessage
                            defaultMessage="Empty content"
                            description="Text for tip7"
                            id="gui.menuBar.tip7"
                        />
                    </div>
                    <div className={classNames(styles.tip8)}>
                        <FormattedMessage
                            defaultMessage="No device"
                            description="Text for tip8"
                            id="gui.menuBar.tip8"
                        />
                    </div>
                    <div className={classNames(styles.tip9Bg)}>
                        <div className={classNames(styles.tip9)}>
                            <div className={classNames(styles.tip9_title)}>
                                <div className={classNames(styles.modeTip)}>
                                    <FormattedMessage
                                        defaultMessage="line to device"
                                        description="Text for tiptip9"
                                        id="gui.menuBar.tip9"
                                    />
                                </div>
                                <div
                                    className={classNames(styles.closeBox)}
                                    onClick={this.handleClose}
                                >
                                    <img
                                        className={classNames(styles.closeIcon)}
                                        src={closeIcon} />
                                </div>
                            </div>
                            <div>
                                <img
                                    className={classNames(styles.lineBtnIcon, styles.iconBle)}
                                    src={lineBle}
                                    onClick={this.handlelineUsb}
                                />
                                <img
                                    className={styles.lineIcon}
                                    src={line}
                                />
                                <img
                                    className={classNames(styles.lineBtnIcon, styles.iconUsb)}
                                    src={lineUsb}
                                    onClick={this.handlelineHid}
                                />

                            </div>
                            <div
                                className={classNames(styles.bleTip)}
                            >
                                <FormattedMessage
                                    defaultMessage="Bluetooth"
                                    description="Text for Bluetooth"
                                    id="gui.menuBar.ble"
                                />
                            </div>
                            <div
                                className={classNames(styles.usbTip)}
                            >
                                <FormattedMessage
                                    defaultMessage="Usb"
                                    description="Text for Usb"
                                    id="gui.menuBar.usb"
                                />
                            </div>
                        </div>
                    </div>
                    <div className={classNames(styles.tip11Box)}>
                        {/* <FormattedMessage
                            defaultMessage="确认清除所有代码？"
                            description="Text for tip11"
                            id="gui.menuBar.tip11"
                        /> */}
                        {/* <div
                            className={classNames(styles.tip11Btn)}
                            onClick={this.handleClear}
                        >
                            <FormattedMessage
                                defaultMessage="确定"
                                description="Text for clear"
                                id="gui.menuBar.clear"
                            />
                        </div>
                        <div
                            className={classNames(styles.tip11Btn)}
                            onClick={this.handleCancle}
                        >
                            <FormattedMessage
                                defaultMessage="取消"
                                description="Text for cancle"
                                id="gui.gui.cancel"
                            />
                        </div> */}
                        <div className={classNames(styles.tip11)}>
                            <div className={classNames(styles.tip11Title)}>
                                <FormattedMessage
                                    defaultMessage="清除代码"
                                    description="Text for tip11"
                                    id="gui.menuBar.tip11Title"
                                />
                                <div
                                    className={classNames(styles.closeBox)}
                                    onClick={this.handleCancle}
                                >
                                    <img
                                        className={classNames(styles.closeIcon)}
                                        src={closeIcon} />
                                </div>
                            </div>
                            <div className={classNames(styles.tip11Content)}>
                                <div className={classNames(styles.text)}>
                                    <FormattedMessage
                                        defaultMessage="确认清除所有代码？"
                                        description="Text for tip11"
                                        id="gui.menuBar.tip11"
                                    />
                                </div>
                                <div className={classNames(styles.tip11Btn)}>
                                    <button
                                        className={classNames(styles.cancle)}
                                        onClick={this.handleCancle}
                                    >
                                        <FormattedMessage
                                            defaultMessage="取消"
                                            description="Text for cancle"
                                            id="gui.gui.cancel"
                                        />
                                    </button>
                                    <button
                                        className={classNames(styles.confirm)}
                                        onClick={this.handleClear}
                                    >
                                        <FormattedMessage
                                            defaultMessage="确定"
                                            description="Text for clear"
                                            id="gui.menuBar.clear"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classNames(styles.compiling_bg)}>
                        <div className={classNames(styles.compilingtip)}>
                            <FormattedMessage
                                defaultMessage="编译中..."
                                description="Text for compile"
                                id="gui.menuBar.compile"
                            />
                        </div>
                    </div>
                    <div className={styles.progressBg}>
                        <div className={styles.progressBox}>
                            <FormattedMessage
                                defaultMessage="下载中"
                                description="Text for download"
                                id="gui.menuBar.hiddownload"
                            />
                            <progress value='0' max='100' id="progress"></progress>
                        </div>
                    </div>
                    {/* <div className={classNames(styles.menuBarItem)}>
                        {this.props.canShare ? (
                            (this.props.isShowingProject || this.props.isUpdating) && (
                                <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                    {
                                        waitForUpdate => (
                                            <ShareButton
                                                className={styles.menuBarButton}
                                                isShared={this.props.isShared}
                                                // eslint-disable react/jsx-no-bind
                                                onClick={() => {
                                                    this.handleClickShare(waitForUpdate);
                                                }}
                                                // eslint-enable react/jsx-no-bind
                                            />
                                        )
                                    }
                                </ProjectWatcher>
                            )
                        ) : (
                            this.props.showComingSoon ? (
                                <MenuBarItemTooltip id="share-button">
                                    <ShareButton className={styles.menuBarButton} />
                                </MenuBarItemTooltip>
                            ) : []
                        )}
                        {this.props.canRemix ? remixButton : []}
                    </div> */}
                    {/* <div className={classNames(styles.menuBarItem, styles.communityButtonWrapper)}>
                        {this.props.enableCommunity ? (
                            (this.props.isShowingProject || this.props.isUpdating) && (
                                <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                    {
                                        waitForUpdate => (
                                            <CommunityButton
                                                className={styles.menuBarButton}
                                                // eslint-disable react/jsx-no-bind
                                                onClick={() => {
                                                    this.handleClickSeeCommunity(waitForUpdate);
                                                }}
                                                // eslint-enable react/jsx-no-bind
                                            />
                                        )
                                    }
                                </ProjectWatcher>
                            )
                        ) : (this.props.showComingSoon ? (
                            <MenuBarItemTooltip id="community-button">
                                <CommunityButton className={styles.menuBarButton} />
                            </MenuBarItemTooltip>
                        ) : [])}
                    </div> */}
                </div>

                {/* show the proper UI in the account menu, given whether the user is
                logged in, and whether a session is available to log in with */}
                {/* <div className={styles.accountInfoGroup}>
                    <div className={styles.menuBarItem}>
                        {this.props.canSave && (
                            <SaveStatus />
                        )}
                    </div>
                    {this.props.sessionExists ? (
                        this.props.username ? (
                            // ************ user is logged in ************
                            <React.Fragment>
                                <a href="/mystuff/">
                                    <div
                                        className={classNames(
                                            styles.menuBarItem,
                                            styles.hoverable,
                                            styles.mystuffButton
                                        )}
                                    >
                                        <img
                                            className={styles.mystuffIcon}
                                            src={mystuffIcon}
                                        />
                                    </div>
                                </a>
                                <AccountNav
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        {[styles.active]: this.props.accountMenuOpen}
                                    )}
                                    isOpen={this.props.accountMenuOpen}
                                    isRtl={this.props.isRtl}
                                    menuBarMenuClassName={classNames(styles.menuBarMenu)}
                                    onClick={this.props.onClickAccount}
                                    onClose={this.props.onRequestCloseAccount}
                                    onLogOut={this.props.onLogOut}
                                />
                            </React.Fragment>
                        ) : (
                            // ********* user not logged in, but a session exists
                            // ********* so they can choose to log in
                            <React.Fragment>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable
                                    )}
                                    key="join"
                                    onMouseUp={this.props.onOpenRegistration}
                                >
                                    <FormattedMessage
                                        defaultMessage="Join Scratch"
                                        description="Link for creating a Scratch account"
                                        id="gui.menuBar.joinScratch"
                                    />
                                </div>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable
                                    )}
                                    key="login"
                                    onMouseUp={this.props.onClickLogin}
                                >
                                    <FormattedMessage
                                        defaultMessage="Sign in"
                                        description="Link for signing in to your Scratch account"
                                        id="gui.menuBar.signIn"
                                    />
                                    <LoginDropdown
                                        className={classNames(styles.menuBarMenu)}
                                        isOpen={this.props.loginMenuOpen}
                                        isRtl={this.props.isRtl}
                                        renderLogin={this.props.renderLogin}
                                        onClose={this.props.onRequestCloseLogin}
                                    />
                                </div>
                            </React.Fragment>
                        )
                    ) : (
                        // ******** no login session is available, so don't show login stuff
                        <React.Fragment>
                            <div className={classNames(styles.menuBarItem, styles.feedbackButtonWrapper)}>
                                <a
                                    className={styles.feedbackLink}
                                    href="https://scratch.mit.edu/discuss/topic/312261/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <Button
                                        className={styles.feedbackButton}
                                        iconSrc={feedbackIcon}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Give Feedback"
                                            description="Label for feedback form modal button"
                                            id="gui.menuBar.giveFeedback"
                                        />
                                    </Button>
                                </a>
                            </div>
                            {this.props.showComingSoon ? (
                                <React.Fragment>
                                    <MenuBarItemTooltip id="mystuff">
                                        <div
                                            className={classNames(
                                                styles.menuBarItem,
                                                styles.hoverable,
                                                styles.mystuffButton
                                            )}
                                        >
                                            <img
                                                className={styles.mystuffIcon}
                                                src={mystuffIcon}
                                            />
                                        </div>
                                    </MenuBarItemTooltip>
                                    <MenuBarItemTooltip
                                        id="account-nav"
                                        place={this.props.isRtl ? 'right' : 'left'}
                                    >
                                        <div
                                            className={classNames(
                                                styles.menuBarItem,
                                                styles.hoverable,
                                                styles.accountNavMenu
                                            )}
                                        >
                                            <img
                                                className={styles.profileIcon}
                                                src={profileIcon}
                                            />
                                            <span>
                                                {'scratch-cat'}
                                            </span>
                                            <img
                                                className={styles.dropdownCaretIcon}
                                                src={dropdownCaret}
                                            />
                                        </div>
                                    </MenuBarItemTooltip>
                                </React.Fragment>
                            ) : []}
                        </React.Fragment>
                    )}
                </div> */}
            </Box >
        );
    }
}

MenuBar.propTypes = {
    accountMenuOpen: PropTypes.bool,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    autoUpdateProject: PropTypes.func,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canShare: PropTypes.bool,
    className: PropTypes.string,
    editMenuOpen: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    fileMenuOpen: PropTypes.bool,
    intl: intlShape,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isUpdating: PropTypes.bool,
    languageMenuOpen: PropTypes.bool,
    loginMenuOpen: PropTypes.bool,
    onClickAccount: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickFile: PropTypes.func,
    onClickCode: PropTypes.func,
    onClickLanguage: PropTypes.func,
    onClickLogin: PropTypes.func,
    onClickLogo: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickRemix: PropTypes.func,
    onClickSave: PropTypes.func,
    onClickSaveAsCopy: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onOpenTipLibrary: PropTypes.func,
    onopenFeedBack: PropTypes.func,
    onopenLogin: PropTypes.func,
    onRequestCloseAccount: PropTypes.func,
    onRequestCloseEdit: PropTypes.func,
    onRequestCloseFile: PropTypes.func,
    onRequestCloseLanguage: PropTypes.func,
    onRequestCloseLogin: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    projectChanged: PropTypes.bool,
    projectTitle: PropTypes.string,
    renderLogin: PropTypes.func,
    sessionExists: PropTypes.bool,
    showComingSoon: PropTypes.bool,
    username: PropTypes.string,
    onsetLinkMode: PropTypes.func
};

MenuBar.defaultProps = {
    onShare: () => { }
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const user = state.session && state.session.session && state.session.session.user;
    return {
        accountMenuOpen: accountMenuOpen(state),
        fileMenuOpen: fileMenuOpen(state),
        editMenuOpen: editMenuOpen(state),
        isRtl: state.locales.isRtl,
        isUpdating: getIsUpdating(loadingState),
        isShowingProject: getIsShowingProject(loadingState),
        languageMenuOpen: languageMenuOpen(state),
        loginMenuOpen: loginMenuOpen(state),
        projectChanged: state.scratchGui.projectChanged,
        projectTitle: state.scratchGui.projectTitle.title,
        sessionExists: state.session && typeof state.session.session !== 'undefined',
        username: user ? user.username : null,
        isCreateFile: state.scratchGui.menus.isCreateFile,
        isUpdateBox: state.scratchGui.menus.isUpdateBox
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenTipLibrary: () => dispatch(openTipsLibrary()),
    onopenFeedBack: () => dispatch(openFeedBack()),
    onopenLogin: () => dispatch(openLogin()),
    onClickAccount: () => dispatch(openAccountMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onClickFile: () => {
        dispatch(openFileMenu())
    },
    onRequestCloseFile: () => dispatch(closeFileMenu()),
    onClickEdit: () => dispatch(openEditMenu()),
    onRequestCloseEdit: () => dispatch(closeEditMenu()),
    onClickLanguage: () => dispatch(openLanguageMenu()),
    onRequestCloseLanguage: () => dispatch(closeLanguageMenu()),
    onClickLogin: () => dispatch(openLoginMenu()),
    onRequestCloseLogin: () => dispatch(closeLoginMenu()),
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
    onClickRemix: () => dispatch(remixProject()),
    onClickSave: () => dispatch(manualUpdateProject()),
    onClickSaveAsCopy: () => dispatch(saveProjectAsCopy()),
    onSeeCommunity: () => dispatch(setPlayer(true)),
    onOpenCreateFile: () => dispatch(openCreateFile()),
    onCloseCreateFile: () => dispatch(closeCreateFile()),
    btnFalse: () => dispatch(btnHideFalse()),
    onsetLinkMode: mode => dispatch(setLinkMode(mode)),
    setSaveFilePath: path => dispatch(setSaveFilePath(path)),
    setSavePythonPath: path => dispatch(setSavePythonPath(path))
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuBar));
